import { render, staticRenderFns } from "./Projet.vue?vue&type=template&id=8bccf704&scoped=true&lang=true&"
import script from "./Projet.vue?vue&type=script&lang=js&"
export * from "./Projet.vue?vue&type=script&lang=js&"
import style0 from "./Projet.vue?vue&type=style&index=0&id=8bccf704&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bccf704",
  null
  
)

export default component.exports